import React, { useEffect } from "react";
import NavBar from "./NavBar";
import ToggleSwitch from "./ToggleSwitch";
import SiteLogo from "./SiteLogo";
import MusicWireTicker from "./MusicWireTicker";

const MainLayout = ({ mode, children }) => {
  useEffect(() => {
    document.body.classList.remove("song-mode", "show-mode");
    document.body.classList.add(mode);

    return () => document.body.classList.remove(mode);
  }, [mode]);

    return (
  <>
    <NavBar />
    <MusicWireTicker />
    <div className="mobile-header-bar"></div>  
    <div className="main-content">
      <SiteLogo />
      <ToggleSwitch />
      {children}
    </div>
  </>
);
};


export default MainLayout;
